import router from '@/router'
import store from '@/store'
/**
 * 免登录白名单
 */
// 2026-09-03：维护应急入口必须在未登录时可达，页面内部再严格校验平台超级管理员身份。
const whiteList:string[] = ['/login','/basy','/maintenance-access']
/**
 * 路由前置处理
 */
router.beforeEach(async (to, from, next) => {
  if (store.getters.token) {
    if (to.path === '/login') {
      next('/')
      return
    }
    if(!store.getters.hasUserInfo){
      await store.dispatch('user/getUserInfo')
    }
    // 2026-08-18：分店 B 端权限是跨机构配置，仅平台超级管理员可进入；后端同时强制校验。
    if(to.meta.requiresPlatformSuperAdmin
      && (store.getters.userInfo.orgId !== 1000 || store.getters.userInfo.roleId !== 1)){
      next('/')
      return
    }
    // 2026-08-30：VIP角色总控统一使用平台超管路由守卫，不再接受任何分店有效功能或历史缓存放行。
    next()
  } else {
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next('/login')
    }
  }
})
